/* 🤖 this file was generated by svg-to-ts */
export const matIconTurnSharpRight: {
  name: 'turn-sharp-right';
  data: string;
} = {
  name: 'turn-sharp-right',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m18 6.83 1.59 1.59L21 7l-4-4-4 4 1.41 1.41L16 6.83V13H8c-1.1 0-2 .9-2 2v6h2v-6h8c1.1 0 2-.9 2-2V6.83z"/></svg>`
};
